import { render, staticRenderFns } from "./UtilMembershipStatusIcon.vue?vue&type=template&id=34f99c51"
import script from "./UtilMembershipStatusIcon.vue?vue&type=script&lang=js"
export * from "./UtilMembershipStatusIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports